import { render, staticRenderFns } from "./advertiserManage.vue?vue&type=template&id=5038d503&scoped=true"
import script from "./advertiserManage.vue?vue&type=script&lang=js"
export * from "./advertiserManage.vue?vue&type=script&lang=js"
import style0 from "./advertiserManage.vue?vue&type=style&index=0&id=5038d503&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5038d503",
  null
  
)

export default component.exports